module.exports = __webpack_public_path__ + "img/page_text_bg.cdef598e.png";